import React from 'react';
import PropTypes from 'prop-types';
import whiteGridLogo from 'assets/images/logos/white-grid-logo.png';

/**
 * MobileFAB - Mobile Floating Action Button for Gigabot
 *
 * Props:
 * - isVisible: boolean - Whether the FAB should be visible
 * - onClick: function - Callback when FAB is clicked
 */
export const MobileFAB = ({ isVisible = true, onClick }) => {
  if (!isVisible) return null;

  return (
    <button
      className='gigabot-fab'
      onClick={onClick}
      aria-label='Open Gigabot chat'
    >
      <img src={whiteGridLogo} alt='Gigabot' width='35' height='35' />
    </button>
  );
};

MobileFAB.propTypes = {
  isVisible: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
};

export default MobileFAB;
